module.exports = __webpack_public_path__ + "media/images/sales-app-image-7fbe3cafe338ac386a148492a169291c.png";